import { Component, Input } from '@angular/core';
import { InvoiceDetailService } from '../services/invoice.detail.service';



@Component({
  selector: 'app-invoice-detail-view',
  templateUrl: './invoice-detail-view.component.html'
})
export class InvoiceDetailViewComponent {
  @Input() invoiceID: number;

  constructor(public service: InvoiceDetailService) {

  }

  ngOnInit() {
    this.service.invoiceID = this.invoiceID;
  }


}
